import { render } from "./Footer.vue?vue&type=template&id=6e8bd19a&scoped=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6e8bd19a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e8bd19a"

export default script